import '@/application/i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { QueryClientProvider } from '@tanstack/react-query'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { Toaster } from 'sonner'
import { router } from './application/router'
import { queryClient } from './application/queryClient'
import { ThemeProvider } from './ui/components/common/ThemeProvider'
import { registerServiceWorker } from './application/pwa/registerServiceWorker'
import { captureBeforeInstallPrompt } from './application/pwa/beforeInstallPrompt'
import './ui/styles/global.css'

const rawKey: unknown = import.meta.env.VITE_RECAPTCHA_SITE_KEY
const recaptchaSiteKey: string | undefined = typeof rawKey === 'string' ? rawKey : undefined

const AppTree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouterProvider router={router} />
        <Toaster richColors position="top-right" />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
)

ReactDOM.createRoot(document.getElementById('root')!).render(
  recaptchaSiteKey ? (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>{AppTree}</GoogleReCaptchaProvider>
  ) : (
    AppTree
  ),
)

// Registered before the first render: Chromium fires `beforeinstallprompt`
// early and only honours a synchronous `preventDefault()`, so a React effect
// would miss it.
captureBeforeInstallPrompt()

registerServiceWorker()
